// src/i18n/translations.js

export const TRANSLATIONS = {
  es: {
    settings:"Configuración",
    unit: "Unidad",
    title: "Lista de Categorías para Buscar",
    searchPlaceholder: "Buscar categorías por nombre...",
    languageToggle: "Cambiar a Inglés (EN)",
    uploadImage: "Subir Recibo",
    showMore: "Ver todas las opciones",
    showLess: "Ocultar opciones",

    errorFetch: "No se pudo obtener la lista de categorías",
    loadingCategories: "Cargando categorías...",
    selectCategoryError: "Por favor, selecciona al menos una categoría.",
    errorSend: "Error al enviar las categorías: ",
    errorSendingCategories: "Hubo un error al enviar las categorías.",
    selectAll:"Seleccionar todo",
    unselectAll:"Deseleccionar todo",
    buttonSearching: "Buscando...",
    buttonSearch: "Buscar",
    loadingItems: "Cargando Artículos...",
    resultsTitle: "Resultados de Búsqueda",
    totalAmountTitle: "Monto Total Requerido:",
    storeSubtotal: "Subtotal:",
    selectionIndicator: "Seleccionado",
    backButton: "Categorías",

    generateListButton: "Nota",
    shoppingListModalTitle: "Lista de Compras",
    copyButton: "Enviar",
    copySuccess: "¡Lista copiada al portapapeles!",
    noItemsSelected: "No hay artículos seleccionados para generar la lista.",
    removeFromShoppingList: "Quitar de la lista de compras",
    increaseQuantity: "Aumentar cantidad",
    decreaseQuantity: "Disminuir cantidad",
    viewItemDetail: "Ver detalle del artículo",
    closeItemDetail: "Cerrar detalle del artículo",

    modalTitle: "Subir Imagen Recibo",
    modalDescription: "Selecciona una imagen para subir (solo JPG, PNG).",
    modalChooseFile: "Elegir Recibo",
    modalPreview: "Previsualización:",
    modalUpload: "Cargar Recibo",
    modalUploading: "Cargando...",
    modalClose: "Cerrar",
    modalErrorType: "Error: Solo se permiten archivos JPG y PNG.",
    modalErrorSelect: "Por favor, selecciona un archivo.",
    modalSuccess: (fileName, gcsUri) =>
      `¡Archivo subido con éxito`,

    itemStore: "Tienda:",
    stores:"Tiendas",
    contactUsTitle: "Contáctanos",
    contactUsPrompt: "¿Tienes preguntas, sugerencias o encontraste un problema?",
    itemCategory: "Categoría",
    alternatives: "Otras opciones",
    itemCreated: "Creado el:",
    itemOffer: "¡Oferta!",
    // SHOP-128: savings badge label, rendered as "{savingsBadge} {pct}%" -
    // no in-string interpolation, matching the rest of this file's convention
    // (e.g. itemOffer above, concatenated with item.special in JSX).
    savingsBadge: "Ahorras",
    // SHOP-153: regular-price fallback label, rendered as "{regularPriceLabel} $X.XX"
    // for an expired item shown at regular_price (SHOP-147) - same convention as savingsBadge above.
    regularPriceLabel: "Reg.",
    otherCategories: "Otras Categorías",
    noResults: "No se encontraron artículos económicos para las categorías seleccionadas.",
    subcategoryItemsModalTitle: "Artículos",
    subcategoryItemsEmpty: "No hay artículos activos en esta subcategoría.",
    viewSubcategoryItems: "Ver artículos de la subcategoría",
    takePhoto: "Tomar foto",
    chooseFromGallery: "Elegir de galería",
    receiptHint: "Foto clara del recibo de compra",
    openCamera: "Abrir cámara",
    openGallery: "Abrir galería",
    addToWatchList: "Añadir a lista de seguimiento",
    removeFromWatchList: "Quitar de lista de seguimiento",
    watchToggleError: "No se pudo actualizar la lista de seguimiento.",
    watchCategory: "Seguir categoría",
    unwatchCategory: "Dejar de seguir categoría",
    categoryWatchToggleError: "No se pudo actualizar la categoría en seguimiento.",
    collapseCategory: "Click para colapsar categoría",
    expandCategory: "Click para expandir categoría",
    // SHOP-203: title text for the collapsed-category "has a selection inside" checkmark badge
    hasSelectedSubcategory: "Contiene una subcategoría seleccionada",
    profile: "Perfil",
    signIn: "Iniciar sesión",
    moreOptions: "Más opciones",
    myWatchedItems: "Mis artículos en seguimiento",
    myFavoriteItems: "Mis artículos favoritos",
    priceAnalytics: "Análisis de precios",
    myWatchedCategories: "Mis categorías en seguimiento",
    onlyActiveItemsLabel: "Solo items vigentes",
    sortByUnitPriceLabel: "Ordenar por precio unitario",
    watchedItemsEmpty: "Aún no tienes artículos en seguimiento.",
    watchedItemUnavailable: "No disponible",
    watchedCategoriesEmpty: "Aún no tienes categorías en seguimiento.",
    bestPrice: "Mejor precio visto",
    bestUnitPrice: "Mejor precio por unidad",
    historicLowPill: "Mínimo histórico",
    historicHighPill: "Cerca del máximo",
    priceAlertPill: "Alerta de precio",
    priceRangeMin: "Mín",
    priceRangeMax: "Máx",
    cheaperEquivalentLabel: "También disponible por menos",
    addToCart: "Añadir al carrito",
    addedToCartToast: "Añadido al carrito",
    expiredItemAddedToast: "Este artículo puede tener el precio desactualizado",
    chooseCartItemTitle: "¿Cuál deseas añadir?",
    addEquivalentItemLabel: "Añadir item equivalente",
    addBothItemsLabel: "Añadir ambos items",
    continueWithOriginalLabel: "Continuar con el item original",
    cancel: "Cancelar",
    searchWatchedCategories: "Buscar con categorías en seguimiento",
    watchedCategoryUnavailable: "No disponible en las tiendas seleccionadas",
    watchedCategoriesAllUnavailable: "Ninguna de tus categorías en seguimiento tiene artículos disponibles en las tiendas seleccionadas.",
    watchedCategoriesExcludedNotice: "Excluidas (sin artículos disponibles):",
    watchedCategoriesConflictPrompt: "Ya tienes categorías seleccionadas. ¿Buscar solo con tus categorías en seguimiento, o combinarlas con tu selección actual?",
    watchedCategoriesConflictWatchedOnly: "Solo en seguimiento",
    watchedCategoriesConflictUnion: "Combinar con selección actual",
    askCopilot: "Pregúntale a Copilot",
    askCopilotTitle: "Pregúntale a Copilot",
    askPlaceholder: "Escribe tu pregunta...",
    askButtonLabel: "Enviar",
    askSending: "Pensando...",
    askError: "No se pudo obtener respuesta. Intenta de nuevo.",
    askEmptyState: "Pregúntame sobre precios y disponibilidad de productos en los supermercados.",
  },

  en: {
    settings:"Settings",
    unit: "Unit",
    itemOffer: "¡Special!",
    // SHOP-128: savings badge label, rendered as "{savingsBadge} {pct}%" -
    // no in-string interpolation, matching the rest of this file's convention.
    savingsBadge: "Save",
    // SHOP-153: regular-price fallback label, rendered as "{regularPriceLabel} $X.XX"
    // for an expired item shown at regular_price (SHOP-147) - same convention as savingsBadge above.
    regularPriceLabel: "Reg.",
    title: "List of Categories to Search",
    searchPlaceholder: "Search categories by name...",
    languageToggle: "Switch to Spanish (ES)",
    uploadImage: "Upload Receipt",
    itemStore: "Store:",
    stores:"Stores",
    contactUsTitle: "Contact Us",
    contactUsPrompt: "Have questions, suggestions, or found an issue?",
    errorFetch: "Could not retrieve the list of categories",
    loadingCategories: "Loading categories...",
    selectCategoryError: "Please select at least one category.",
    errorSend: "Error sending categories: ",
    errorSendingCategories: "There was an error sending categories.",
    selectAll:"Check All",
    unselectAll:"Uncheck All",
    buttonSearching: "Searching...",
    buttonSearch: "Search",
    loadingItems: "Loading Items...",
    resultsTitle: "Search Results",
    totalAmountTitle: "Required Total Amount:",
    storeSubtotal: "Subtotal:",
    selectionIndicator: "Selected",
    backButton: "Categories",

    generateListButton: "List",
    shoppingListModalTitle: "Shopping List",
    copyButton: "Share",
    copySuccess: "List copied to clipboard!",
    noItemsSelected: "No items selected to generate list.",
    removeFromShoppingList: "Remove from shopping list",
    increaseQuantity: "Increase quantity",
    decreaseQuantity: "Decrease quantity",
    viewItemDetail: "View item detail",
    closeItemDetail: "Close item detail",

    modalTitle: "Upload Receipt Image",
    modalDescription: "Select an image to upload (JPG, PNG only).",
    modalChooseFile: "Choose Receipt",
    modalPreview: "Preview:",
    modalUpload: "Upload Receipt",
    modalUploading: "Uploading...",
    modalClose: "Close",
    modalErrorType: "Error: Only JPG and PNG files are allowed.",
    modalErrorSelect: "Please select a file.",
    modalSuccess: (fileName, gcsUri) =>
      `File uploaded successfully`,
    takePhoto: "Take photo",
    chooseFromGallery: "Choose from gallery",
    receiptHint: "Clear photo of the purchase receipt",
    openCamera: "Open camera",
    openGallery: "Open gallery",
    alternatives: "Other options",
    subcategoryItemsModalTitle: "Items",
    subcategoryItemsEmpty: "No active items in this subcategory.",
    viewSubcategoryItems: "View subcategory items",
    showMore: "View ${count} more",
    showLess: "View less",  showMore: "See all options",
    showLess: "Hide options",
    addToWatchList: "Add to watch list",
    removeFromWatchList: "Remove from watch list",
    watchToggleError: "Couldn't update your watch list.",
    watchCategory: "Watch category",
    unwatchCategory: "Unwatch category",
    categoryWatchToggleError: "Couldn't update the watched category.",
    collapseCategory: "Click to collapse category",
    expandCategory: "Click to expand category",
    // SHOP-203: title text for the collapsed-category "has a selection inside" checkmark badge
    hasSelectedSubcategory: "Contains a selected subcategory",
    profile: "Profile",
    signIn: "Sign in",
    moreOptions: "More options",
    myWatchedItems: "My Watched Items",
    myFavoriteItems: "My Favorite Items",
    priceAnalytics: "Price Analytics",
    myWatchedCategories: "My Watched Categories",
    onlyActiveItemsLabel: "Only active items",
    sortByUnitPriceLabel: "Sort by unit price",
    watchedItemsEmpty: "No watched items yet.",
    watchedItemUnavailable: "Not available",
    watchedCategoriesEmpty: "No watched categories yet.",
    bestPrice: "Best price seen",
    bestUnitPrice: "Best unit price",
    historicLowPill: "Historic low",
    historicHighPill: "Near max price",
    priceAlertPill: "Price alert",
    priceRangeMin: "Min",
    priceRangeMax: "Max",
    cheaperEquivalentLabel: "Also available for less",
    addToCart: "Add to cart",
    addedToCartToast: "Added to cart",
    expiredItemAddedToast: "This item's price may be outdated",
    chooseCartItemTitle: "Which one do you want to add?",
    addEquivalentItemLabel: "Add equivalent item",
    addBothItemsLabel: "Add both items",
    continueWithOriginalLabel: "Continue with original item",
    cancel: "Cancel",
    searchWatchedCategories: "Search with watched categories",
    watchedCategoryUnavailable: "Not available for the selected stores",
    watchedCategoriesAllUnavailable: "None of your watched categories have items available for the selected stores.",
    watchedCategoriesExcludedNotice: "Excluded (no items available):",
    watchedCategoriesConflictPrompt: "You already have categories selected. Search with only your watched categories, or combine them with your current selection?",
    watchedCategoriesConflictWatchedOnly: "Watched only",
    watchedCategoriesConflictUnion: "Combine with current selection",
    askCopilot: "Ask Copilot",
    askCopilotTitle: "Ask Copilot",
    askPlaceholder: "Type your question...",
    askButtonLabel: "Send",
    askSending: "Thinking...",
    askError: "Couldn't get an answer. Please try again.",
    askEmptyState: "Ask me about prices and product availability across supermarkets.",
  }
};
